import React from "react";
import { textCase } from "../../../../service/ui/UI";
import { IconNormal } from "../../../../widget/common/ui/Icon";

const ConversationForwaredLabel = () => {
  return (
    <div className="d-flex align-items-center font-gotham-book color-grey1 font-size-12_13 pb-1">
      <IconNormal size={18} name="forward" />
      <span className="ps-1">{textCase("forwarded")}</span>
    </div>
  );
};

export default ConversationForwaredLabel;
